









import { computed, defineComponent } from '@nuxtjs/composition-api';

import { useActivePerformances } from '@/composables/performances';

export default defineComponent({
  name: 'RelatedPerformances',
  props: {
    currentPerformanceId: {
      type: String,
      default: '',
      required: true,
    },
  },
  setup: (props) => {
    const { performances, performancesLoading } = useActivePerformances({ limit: 8 });
    const filteredPerformances = computed(() => performances.value.filter(performance => performance.id !== props.currentPerformanceId));

    return ({
      performances,
      performancesLoading,
      filteredPerformances,
    });
  },
});
